import { AxiosError } from "axios";
import { enqueueSnackbar } from "@powerdiary/components-library/lib/components/Snackbar";
import { useGetQuery, useDefaultHandleAxiosErrorProps } from "../../../hooks/useClientPortalQuery";
import { handleAxiosError } from "../../../hooks/useClientPortalQuery.helpers";
import { useClientPortalConfigContext } from "../../../context";
import { ApiErrorResponse, CustomFormModel } from "../../../types/generated/models";

interface IUseGetCustomFormParams {
    publicId: string;
    formDataNumber: number;
    token?: string;
}

export function useGetCustomForm(params: IUseGetCustomFormParams) {
    const { clientPortalGuid } = useClientPortalConfigContext();
    const errorProps = useDefaultHandleAxiosErrorProps();

    const queryParams = new URLSearchParams();
    queryParams.append("publicId", params.publicId);
    queryParams.append("formDataNumber", params.formDataNumber.toString());
    if (params.token) {
        queryParams.append("token", params.token);
    }

    return useGetQuery<CustomFormModel>({
        url: `/api/v1/${clientPortalGuid}/CustomForm/GetForm?${queryParams.toString()}`,
        handleCustomError: (error: AxiosError) => {
            const data = error.response?.data;
            // Title the unavailable-form message "Form Not Found" instead of the shared generic "Request error".
            if (error.response?.status === 400 && typeof data === "object" && data !== null) {
                const { message } = data as ApiErrorResponse;
                if (message) {
                    enqueueSnackbar(message, { variant: "error", alertTitle: "Form Not Found" });
                    return;
                }
            }
            handleAxiosError({ ...errorProps, error });
        },
    });
}
